import { UseFormSetValue } from 'react-hook-form'
import { FormData } from './types'

export const initializeFormValues = (
  product: any,
  setValue?: UseFormSetValue<FormData>
): FormData | null => {
  if (!product) return null

  // Normalize print_codes for text input: DB stores array, form uses comma-separated string
  const rawPrintCodes = product?.print_codes
  const print_codes = Array.isArray(rawPrintCodes)
    ? rawPrintCodes.join(', ')
    : typeof rawPrintCodes === 'string'
    ? rawPrintCodes
    : ''

  const formData: FormData = {
    article_number: product?.article_number || '',
    item_name: product?.item_name || '',
    item_description: product?.item_description || '',
    source: product?.source || '',
    brand_name: product?.brand_name || null,
    is_draft: product?.is_draft || false,
    default_print_technique: product?.default_print_technique || null,
    delivery_time: product?.delivery_time || null,
    item_name_translations: product?.item_name_translations || null,
    item_description_translations:
      product?.item_description_translations || null,
    packaging_cost: product?.packaging_cost || null,
    has_variants: product?.has_variants || false,
    margin: product?.margin ?? 0,
    moq: product?.moq ?? 0,
    print_codes,
    fast_track: product?.fast_track || false,
    cost: product?.cost || 0,
    price: product?.price || 0,
    profit: (product?.price || 0) - (product?.cost || 0),
    klayder_recommendation_text: product?.klayder_recommendation_text || null,
    klayder_recommends: product?.klayder_recommends || false,
    related_product_ids: product?.related_product_ids as any,
  }

  // If setValue is provided, use it (for backward compatibility)
  if (setValue) {
    Object.entries(formData).forEach(([key, value]) => {
      setValue(key as keyof FormData, value as any)
    })
  }

  return formData
}

/** Convert form string to JSON array for jsonb column */
const parsePrintCodesForDb = (value: unknown): string[] | null => {
  if (value === null || value === undefined) return null
  if (Array.isArray(value))
    return value.filter((v): v is string => typeof v === 'string')
  if (typeof value === 'string') {
    const codes = value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
    return codes.length ? codes : null
  }
  return null
}

export const transformFormDataForUpdate = (
  values: FormData,
  productId: number
) => {
  return {
    id: productId,
    article_number: values.article_number,
    item_name: values.item_name,
    item_description: values.item_description,
    source: values.source,
    brand_name: values.brand_name,
    is_draft: Boolean(values.is_draft),
    default_print_technique: values.default_print_technique,
    delivery_time: values.delivery_time,
    item_name_translations: values.item_name_translations,
    item_description_translations: values.item_description_translations,
    packaging_cost: Number(values.packaging_cost),
    print_codes: parsePrintCodesForDb(values.print_codes),
    has_variants: Boolean(values.has_variants),
    margin:
      typeof values.margin === 'string' ? Number(values.margin) : values.margin,
    moq: values.moq,
    fast_track: values.fast_track,
    cost: Number(values.cost),
    price: Number(values.price),
    klayder_recommendation_text: values.klayder_recommendation_text,
    klayder_recommends: values.klayder_recommends,
    related_product_ids: values.related_product_ids,
  }
}
